import { createRouter, createWebHistory } from 'vue-router';
import LoginView from '../views/LoginView.vue';
import DashboardView from '../views/DashboardView.vue';
import CatalogsView from '../views/CatalogsView.vue';
import ClientsView from '../views/ClientsView.vue';
import UsersView from '../views/UsersView.vue';
import SessionRoomView from '../views/SessionRoomView.vue';
import ClientSessionView from '../views/ClientSessionView.vue';

const routes = [
  { path: '/', redirect: '/dashboard' },
  { path: '/login', component: LoginView },
  { path: '/dashboard', component: DashboardView, meta: { auth: true } },
  { path: '/catalogs', component: CatalogsView, meta: { auth: true } },
  { path: '/clients', component: ClientsView, meta: { auth: true } },
  { path: '/users', component: UsersView, meta: { auth: true, admin: true } },
  { path: '/sessions/:id', component: SessionRoomView, meta: { auth: true } },
  { path: '/session/:token', component: ClientSessionView },
];

const router = createRouter({ history: createWebHistory(), routes });

router.beforeEach((to) => {
  if (to.meta.auth && !localStorage.getItem('auth_token')) return '/login';
  if (to.meta.admin) {
    const user = JSON.parse(localStorage.getItem('auth_user') || '{}');
    if (!user.roles?.includes('admin')) return '/dashboard';
  }
  return true;
});

export default router;
